import React from "react";
import { useTranslation } from "react-i18next";

const Terms = () => {
  const { t } = useTranslation();
  return (
    <div className="max-w-10/12 mx-auto p-4">
      <header className="text-center mb-8">
        <h1 className="text-3xl font-bold">{t("terms.title")}</h1>
      </header>
      <section className="space-y-8">
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">{t("terms.introTitle")}</h2>
          <p className="text-gray-700">
            {t("terms.introBody")}
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">{t("terms.useTitle")}</h2>
          <p className="text-gray-700">
            {t("terms.useBody")}
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">
            {t("terms.ipTitle")}
          </h2>
          <p className="text-gray-700">
            {t("terms.ipBody")}
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">
            {t("terms.liabilityTitle")}
          </h2>
          <p className="text-gray-700">
            {t("terms.liabilityBody")}
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">
            {t("terms.changesTitle")}
          </h2>
          <p className="text-gray-700">
            {t("terms.changesBody")}
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">{t("terms.contactTitle")}</h2>
          <p className="text-gray-700">
            {t("terms.contactBody")}
          </p>
        </div>
      </section>
    </div>
  );
};

export default Terms;
